
// the zamalian configuration
const firebaseConfig = {
    apiKey: "AIzaSyCh5oW041r0hS3KFb1zFHfkVbqVBSKt0Ko",
    authDomain: "doctor-mamma.firebaseapp.com",
    projectId: "doctor-mamma",
    storageBucket: "doctor-mamma.appspot.com",
    messagingSenderId: "367966567184",
    appId: "1:367966567184:web:74347dcbc93d16b45d0395"
};

/* 
// sabbir ahmed configuration
const firebaseConfig = {
    apiKey: "AIzaSyAz6NTGqyAGYcahczeEqEUPdtt6PnWoAHg",
    authDomain: "dr-mamma.firebaseapp.com",
    projectId: "dr-mamma",
    storageBucket: "dr-mamma.appspot.com",
    messagingSenderId: "295650559175",
    appId: "1:295650559175:web:fb1496b02e317d26ba2ae2"
};
 */
export default firebaseConfig;